<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div>
              <!-- <span class="loading-request" v-show="loading"></span> -->
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
              >
                <h1 class="h2">Relatório de Consumo</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                  <div
                    class="btn-group btn-group-sm"
                    role="group"
                    aria-label="Menu dos Consumo"
                  >
                    <span
                      class="btn btn-outline-brand"
                      @click="openInvoiceLoose('add')"
                      v-b-tooltip.hover
                      title="Nova Fatura Avulsa!"
                    >
                      <i class="fas fa-plus-square"></i>&nbsp; Fatura Avulsa
                    </span>
                  </div>
                </div>
              </div>
              <div
                id="alert"
                class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
                :class="alert.color"
                role="alert"
                v-if="alert.message"
              >
                <button
                  type="button"
                  class="close"
                  aria-label="Close"
                  @click="alert.message = ''"
                ></button>
                <i :class="alert.icon"></i> &nbsp;<strong>{{
                  alert.message
                }}</strong
                ><br />
                {{ alert.reason }}
              </div>
              <div>
                <div class="float-left">
                  <div class="dropdown">
                    <button
                      class="btn btn-sm btn-primary dropdown-toggle"
                      type="button"
                      id="actionsDDButton"
                      :disabled="invoiceIds.length < 1"
                      :title="
                        invoiceIds.length < 1
                          ? 'Necessário selecionar mais de 1 fatura'
                          : 'Selecione uma ação para executar nas faturas selecionadas'
                      "
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fal fa-cog"></i> Ações
                    </button>
                    <div
                      class="dropdown-menu"
                      aria-labelledby="actionsDDButton"
                    >
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent.stop="deleteMultipleInvoices()"
                        ><i class="fal fa-trash m--font-metal"></i> Excluir</a
                      >
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent.stop="confirmSendEmails()"
                        ><i class="fal fa-paper-plane m--font-metal"></i> Enviar
                        faturas via e-mail</a
                      >
                      <button
                        class="sub dropdown-item"
                        id="actionsDDButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                      >
                        <i class="fal fa-cog"></i> Alterar status
                      </button>
                      <li class="dropdown-submenu dropright">
                        <ul class="dropdown-menu force-right-menu">
                          <li>
                            <a
                              href="#"
                              class="dropdown-item"
                              @click.prevent.stop="
                                changeMultipleInvoiceStatus(0)
                              "
                              ><i class="fal fa-circle m--font-danger"></i> Não
                              conferido</a
                            >
                          </li>
                          <li>
                            <a
                              href="#"
                              class="dropdown-item"
                              @click.prevent.stop="
                                changeMultipleInvoiceStatus(1)
                              "
                              ><i class="fal fa-circle m--font-primary"></i>
                              Conferido</a
                            >
                          </li>
                        </ul>
                      </li>
                      <a
                        class="dropdown-item"
                        href="#"
                        @click.prevent.stop="confirmCancelInvoices()"
                        v-b-tooltip.html.bottom
                        title="Faturas com status <b>Paga</b> não podem ser canceladas"
                      >
                        <i class="fal fa-times"></i> Cancelar fatura
                      </a>
                    </div>
                  </div>
                </div>
                <div class="float-left ml-3">
                  <div class="dropdown">
                    <button
                      class="btn btn-sm btn-primary dropdown-toggle"
                      type="button"
                      id="sellDDButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fal fa-cog"></i> Gerar Venda
                    </button>
                    <div class="dropdown-menu" aria-labelledby="sellDDButton">
                      <a
                        href="#"
                        class="dropdown-item"
                        @click.prevent.stop="confirmSendIugu()"
                        ><i class="fas fa-angle-right m--font-metal"></i> Enviar
                        para Iugu</a
                      >
                      <a
                        href="#"
                        class="dropdown-item"
                        @click.prevent.stop="confirmSendERP()"
                        ><i class="fas fa-angle-right m--font-metal"></i> Enviar
                        para ERP</a
                      >
                      <!-- <a href="#" class="dropdown-item" data-toggle="modal" data-target="#generateSaleModal"><i class="fas fa-angle-right m--font-metal"></i> Por grupo</a> -->
                      <a
                        href="#"
                        class="dropdown-item"
                        @click.prevent.stop="generateInvoiceSale()"
                        ><i class="fas fa-angle-right m--font-metal"></i> Enviar
                        para Conta Azul</a
                      >
                      <a
                        href="#"
                        class="dropdown-item"
                        @click.prevent.stop="generateInvoiceWorkOrder()"
                        ><i class="fas fa-angle-right m--font-metal"></i> Enviar
                        para Omie</a
                      >
                    </div>
                  </div>
                </div>
                <div class="float-left ml-3">
                  <div class="dropdown">
                    <button
                      class="btn btn-sm btn-primary dropdown-toggle"
                      type="button"
                      id="logsButton"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <i class="fal fa-cog"></i> Logs
                      <span
                        v-if="omieAlerts.consumption > 0"
                        class="badge badge-danger ml-1"
                        title="Erros de envio não vistos"
                        >{{ formatAlertCount(omieAlerts.consumption) }}</span
                      >
                    </button>
                    <div class="dropdown-menu" aria-labelledby="logsButton">
                      <a
                        href="#"
                        class="dropdown-item"
                        @click.prevent.stop="openOmieEmailSendLogs()"
                        ><i class="fas fa-angle-right m--font-metal"></i> Envio
                        de E-mail
                        <span
                          v-if="omieAlerts.email > 0"
                          class="badge badge-danger ml-1"
                          >{{ formatAlertCount(omieAlerts.email) }}</span
                        ></a
                      >
                      <a
                        href="#"
                        class="dropdown-item"
                        @click.prevent.stop="openOmieInvoiceSendLogs()"
                        ><i class="fas fa-angle-right m--font-metal"></i> Envio
                        de Fatura
                        <span
                          v-if="omieAlerts.invoice > 0"
                          class="badge badge-danger ml-1"
                          >{{ formatAlertCount(omieAlerts.invoice) }}</span
                        ></a
                      >
                    </div>
                    <button
                      class="btn btn-sm btn-primary ml-3"
                      type="button"
                      id="actionDownloadList"
                      @click="download()"
                    >
                      {{ downloading ? 'Baixando...' : 'Baixar Planilha' }}
                    </button>
                  </div>
                </div>

                <div class="page-amounts">
                  <nav aria-label="...">
                    <ul class="pagination pagination-md">
                      <li class="page-item" :class="{ selected: amount == 3 }">
                        <a
                          @click.prevent.stop="setAmountPerPage(3)"
                          class="page-link paginate"
                          >3</a
                        >
                      </li>
                      <li class="page-item" :class="{ selected: amount == 10 }">
                        <a
                          @click.prevent.stop="setAmountPerPage(10)"
                          class="page-link paginate"
                          >10</a
                        >
                      </li>
                      <li class="page-item" :class="{ selected: amount == 50 }">
                        <a
                          @click.prevent.stop="setAmountPerPage(50)"
                          class="page-link paginate"
                          >50</a
                        >
                      </li>
                      <li
                        class="page-item"
                        :class="{ selected: amount == 100 }"
                      >
                        <a
                          @click.prevent.stop="setAmountPerPage(100)"
                          class="page-link paginate"
                          >100</a
                        >
                      </li>
                      <li
                        class="page-item"
                        :class="{ selected: amount == 150 }"
                      >
                        <a
                          @click.prevent.stop="setAmountPerPage(150)"
                          class="page-link paginate"
                          >150</a
                        >
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              <div class="paginator-info-top m-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um
                  total de {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else
                  >Nenhum item a ser exibido.</span
                >
              </div>
            </div>
            <div class="table-responsive">
              <div class="container-table">
                <table
                  class="table table-striped- table-bordered table-hover table-checkable"
                >
                  <thead>
                    <tr>
                      <td class="text-center align-middle" width="20">
                        <label
                          class="m-checkbox m-checkbox--single m-checkbox--solid m-checkbox--brand mb-0 mt-0"
                          v-b-tooltip.hover
                          title="Selecionar todas faturas dessa página"
                        >
                          <input
                            type="checkbox"
                            @click="selectAllReport"
                            v-model="allSelected"
                            class="m-group-checkable"
                          />
                          <span></span>
                        </label>
                      </td>
                      <td
                        style="white-space: nowrap, width:70"
                        class="text-center align-middle pointer"
                        :class="{ 'table-sorted': sortType == 'co_id' }"
                        @click="sortCall('co_id')"
                      >
                        ID Cliente
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'co_id' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'co_id' && sortReverse"
                        ></span>
                        <span
                          class="fal fa-sort sort"
                          v-if="sortType != 'co_id'"
                        ></span>
                      </td>
                      <td
                        style="white-space: nowrap, width:100"
                        class="text-center align-middle pointer"
                      >
                        Cliente
                      </td>
                      <td
                        style="white-space: nowrap, width:100"
                        class="text-center align-middle pointer"
                      >
                        CNPJ/CPF
                      </td>
                      <td
                        tyle="white-space: nowrap, width:60"
                        class="text-center align-middle pointer"
                        :class="{ 'table-sorted': sortType == 'billing_month' }"
                        @click="sortCall('billing_month')"
                      >
                        Mês
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'billing_month' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'billing_month' && sortReverse"
                        ></span>
                        <span
                          class="fal fa-sort sort"
                          v-if="sortType != 'billing_month'"
                        ></span>
                      </td>
                      <td
                        tyle="white-space: nowrap, width:100"
                        class="text-center align-middle pointer"
                        :class="{ 'table-sorted': sortType == 'price_total' }"
                        @click="sortCall('price_total')"
                      >
                        Valor
                        <span
                          class="fas fa-caret-down sorted"
                          v-if="sortType == 'price_total' && !sortReverse"
                        ></span>
                        <span
                          class="fas fa-caret-up sorted"
                          v-if="sortType == 'price_total' && sortReverse"
                        ></span>
                        <span
                          class="fal fa-sort sort"
                          v-if="sortType != 'price_total'"
                        ></span>
                      </td>
                      <td
                        tyle="white-space: nowrap, width:20"
                        class="text-center align-middle"
                      >
                        Tipo
                      </td>
                      <td
                        tyle="white-space: nowrap, width:20"
                        class="text-center align-middle"
                      >
                        Produto
                      </td>
                      <td
                        tyle="white-space: nowrap, width:20"
                        class="text-center align-middle"
                      >
                        Status
                      </td>
                      <td
                        tyle="white-space: nowrap, width:20"
                        class="text-center align-middle"
                      >
                        Data Faturamento
                      </td>
                      <td
                        tyle="white-space: nowrap, width:20"
                        class="text-center align-middle"
                      >
                        Cancelamento
                      </td>
                      <td
                        tyle="white-space: nowrap, width:20"
                        class="text-center align-middle"
                      >
                        Ações
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td></td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueNumber"
                          @input="callData"
                          v-model="filters.id"
                          v-b-tooltip.hover
                          title="Filtrar por ID do Cliente"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.name"
                          v-b-tooltip.hover
                          title="Filtrar por nome do Cliente"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @input="callData"
                          v-model="filters.document"
                          v-b-tooltip.hover
                          title="Filtrar por CNPJ/CPF"
                        />
                      </td>
                      <td>
                        <SelectInvoiceBillingMonth
                          :selected="filters.month"
                          @change="setFilter('month', $event)"
                          class="form-control-sm"
                          v-b-tooltip.hover
                          title="Filtrar por mês de cobrança"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          class="form-control form-control-sm m-input"
                          @keypress="validateValueFloat"
                          @input="callData"
                          v-model="filters.price"
                          v-b-tooltip.hover
                          title="Filtrar por valor total"
                        />
                      </td>
                      <td>
                        <SelectInvoiceTypes
                          :selected="filters.type"
                          @change="setFilter('type', $event)"
                          class="form-control-sm"
                          v-b-tooltip.hover
                          title="Filtrar por tipo"
                        />
                      </td>
                      <td>
                        <SelectProducts
                          :selected="filters.products"
                          @change="setFilter('product', $event)"
                          class="form-control-sm"
                          v-b-tooltip.hover
                          title="Filtrar por Produtos"
                        />
                      </td>
                      <td>
                        <SelectInvoiceStatuses
                          :selected="filters.status"
                          @change="setFilter('status', $event)"
                          class="form-control-sm"
                          v-b-tooltip.hover
                          title="Filtrar por status"
                        />
                      </td>
                      <td>
                        <div class="input-group">
                          <input
                            type="date"
                            name="start"
                            id="startj"
                            max="9999-12-31"
                            class="form-control form-control-sm m-input"
                            v-model="filters.billingDateExternal"
                          />
                        </div>
                      </td>
                      <td>
                        <SelectYesNo
                          :selected="filters.cancellation"
                          :bool="true"
                          @change="setFilter('cancellation', $event)"
                          class="form-control-sm"
                        />
                      </td>
                      <td
                        class="text-center align-middle"
                        tyle="white-space: nowrap"
                      >
                        <button
                          type="button"
                          class="btn btn-outline-brand btn-sm btn-outline-metal btn-filter mr-1"
                          @click="callData"
                          v-b-tooltip.hover
                          title="Clique para filtrar"
                        >
                          <i class="far fa-search"></i> Filtrar
                        </button>
                        <button
                          type="button"
                          class="btn btn-outline-brand btn-sm btn-outline-metal btn-filter"
                          @click="clearFilters"
                          v-b-tooltip.hover
                          title="Clique para limpar os filtros"
                        >
                          <i class="far fa-eraser"></i> Limpar
                        </button>
                      </td>
                    </tr>
                    <tr v-for="(invoice, id) in data.data" :key="id">
                      <td
                        class="text-center align-middle"
                        width="60"
                        v-bind:class="{
                          bgPlan: invoice.plan_id != null,
                          bgSpreadsheet: invoice.is_csv_consumption,
                        }"
                      >
                        <label
                          class="m-checkbox m-checkbox--single m-checkbox--solid m-checkbox--brand mb-0 mt-0"
                          v-b-tooltip.hover.right.title="
                            `#${invoice.id} - Selecionar essa fatura`
                          "
                        >
                          <input
                            type="checkbox"
                            v-model="invoiceIds"
                            @click="select"
                            :value="invoice.id"
                            class="m-group-checkable"
                          />
                          <span></span>
                        </label>
                      </td>
                      <td
                        class="text-center align-middle"
                        v-bind:class="{
                          bgPlan: invoice.plan_id != null,
                          bgSpreadsheet: invoice.is_csv_consumption,
                        }"
                      >
                        {{
                          invoice.company
                            ? invoice.company.id
                            : invoice.customer.id
                        }}
                      </td>
                      <td
                        class="text-left align-middle"
                        v-bind:class="{
                          bgPlan: invoice.plan_id != null,
                          bgSpreadsheet: invoice.is_csv_consumption,
                        }"
                      >
                        {{
                          invoice.company
                            ? invoice.company.name
                            : invoice.customer.customerable.co_name
                            ? invoice.customer.customerable.co_name
                            : invoice.customer.customerable.name
                        }}
                      </td>
                      <td
                        class="text-left align-middle"
                        v-bind:class="{
                          bgPlan: invoice.plan_id != null,
                          bgSpreadsheet: invoice.is_csv_consumption,
                        }"
                      >
                        {{
                          invoice.company
                            ? invoice.company.cnpj
                            : (invoice.customer.documents.value
                                ? invoice.customer.documents.value
                                : '-')
                              | cnpj
                              | cpf
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        v-bind:class="{
                          bgPlan: invoice.plan_id != null,
                          bgSpreadsheet: invoice.is_csv_consumption,
                        }"
                      >
                        {{ invoice.billing_month | month }}
                      </td>
                      <td
                        class="text-right align-middle"
                        v-bind:class="{
                          bgPlan: invoice.plan_id != null,
                          bgSpreadsheet: invoice.is_csv_consumption,
                        }"
                      >
                        {{
                          invoice.discount >
                          invoice.price_total + invoice.price_extra
                            ? 0
                            : (invoice.price_total +
                                invoice.price_extra -
                                invoice.discount)
                              | money
                        }}
                      </td>
                      <td
                        class="text-center align-middle"
                        v-bind:class="{
                          bgPlan: invoice.plan_id != null,
                          bgSpreadsheet: invoice.is_csv_consumption,
                        }"
                      >
                        <span
                          class="m--font-gray"
                          v-if="invoice.contr_id"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Fatura Recorrente"
                          ><i class="fas fa-copy"></i
                        ></span>
                        <span
                          class="m--font-brand"
                          v-else
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Fatura Avulsa"
                          ><i class="fas fa-file"></i
                        ></span>
                      </td>
                      <td
                        class="text-center align-middle"
                        v-bind:class="{
                          bgPlan: invoice.plan_id != null,
                          bgSpreadsheet: invoice.is_csv_consumption,
                        }"
                      >
                        {{ invoice.product.name }}
                      </td>
                      <td
                        tyle="white-space: nowrap"
                        class="text-left align-middle"
                        v-bind:class="{
                          bgPlan: invoice.plan_id != null,
                          bgSpreadsheet: invoice.is_csv_consumption,
                        }"
                      >
                        <span
                          class="m-badge m-badge-outline m-badge--wide m-badge--danger"
                          v-if="invoice.status == 0"
                          >Não Conferida</span
                        >
                        <span
                          class="m-badge m-badge-outline m-badge--wide m-badge--primary"
                          v-if="invoice.status == 1"
                          >Conferida</span
                        >
                        <span
                          class="m-badge m-badge-outline m-badge--wide m-badge--success"
                          v-if="invoice.status == 2"
                          >Venda Realizada</span
                        >
                        <span
                          class="m-badge m-badge-outline m-badge--wide m-badge--dark"
                          v-if="invoice.status == 3"
                          >Cancelada</span
                        >
                        <span
                          class="m-badge m-badge-outline m-badge--wide m-badge--success"
                          v-if="invoice.status == 4"
                          >Paga</span
                        >
                        <span
                          class="m-badge m-badge-outline m-badge--wide m-badge--warning"
                          v-if="invoice.status == 5"
                          >Parcialmente Paga</span
                        >
                        <span
                          class="m-badge m-badge-outline m-badge--wide m-badge--danger"
                          v-if="invoice.status == 6"
                          >Expirado</span
                        >
                        <span class="customIconEmail" v-if="invoice.send_email"
                          ><i
                            class="fal fa-paper-plane fa-lg"
                            data-toggle="tooltip"
                            title="Fatura enviada por email"
                          ></i
                        ></span>
                      </td>
                      <td
                        class="text-center align-middle"
                        v-bind:class="{
                          bgPlan: invoice.plan_id != null,
                          bgSpreadsheet: invoice.is_csv_consumption,
                        }"
                      >
                        {{ invoice.billing_date_external | date }}
                      </td>
                      <td
                        tyle="white-space: nowrap"
                        class="text-center align-middle"
                        v-bind:class="{
                          bgPlan: invoice.plan_id != null,
                          bgSpreadsheet: invoice.is_csv_consumption,
                        }"
                      >
                        {{ invoice.cancellation ? 'Sim' : 'Não' }}
                      </td>
                      <td
                        tyle="white-space: nowrap"
                        class="text-center align-middle"
                        v-bind:class="{
                          bgPlan: invoice.plan_id != null,
                          bgSpreadsheet: invoice.is_csv_consumption,
                        }"
                      >
                        <router-link
                          v-if="invoice.co_id"
                          tag="a"
                          :to="`/reports/invoice/company/${
                            invoice.co_id
                          }/${$options.filters.month(invoice.billing_month)}`"
                          class="icon-circle"
                          v-b-tooltip.hover
                          title="Ver relatório de consumo deste Cliente"
                        >
                          <i class="fas fa-file-invoice-dollar"></i>
                        </router-link>
                        <router-link
                          v-if="!invoice.co_id && invoice.customer_id"
                          tag="a"
                          :to="`/reports/invoice/customer/${invoice.customer_id}/${invoice.id}`"
                          class="icon-circle"
                          v-b-tooltip.hover
                          title="Ver relatório de consumo deste Cliente"
                        >
                          <i class="fas fa-file-invoice-dollar"></i>
                        </router-link>
                        <a
                          href
                          @click.prevent.stop="openSaveInvoice(invoice.id)"
                          class="icon-circle ml-1"
                          v-b-tooltip.hover
                          title="Editar Dados"
                        >
                          <i class="fas fa-edit"></i>
                        </a>
                        <a
                          href
                          @click.prevent.stop="
                            downloadInvoice(
                              invoice.id,
                              invoice.customer_id ? invoice.customer_id : 0,
                              id,
                              invoice.product.name,
                              invoice.billing_month
                            )
                          "
                          class="icon-circle"
                          v-b-tooltip.hover
                          title="Baixar fatura"
                        >
                          <b-spinner
                            style="vertical-align: baseline; margin-top: 2px"
                            small
                            label="Spinning"
                            v-if="
                              (loadingDownload = true && id == indexDownload)
                            "
                          ></b-spinner>
                          <i v-else class="fas fa-download"></i>
                        </a>

                        <a
                          href
                          @click.prevent.stop="
                            openDuplicateInvoice(invoice.id, invoice)
                          "
                          class="icon-circle ml-1"
                          v-b-tooltip.hover
                          title="Segunda via Iugu"
                          :class="{ disabled: invoice.status != 2 }"
                        >
                          <i class="fas fa-copy"></i>
                        </a>
                        <a
                          href=""
                          @click.prevent.stop="confirmDel(invoice.id)"
                          class="icon-circle"
                          :class="{ disabled: invoice.status > 0 }"
                          v-b-tooltip.hover
                          title="Excluir fatura"
                        >
                          <i class="fas fa-trash"></i>
                        </a>
                        <a
                          href
                          @click.prevent.stop="openLogEmail(invoice.id)"
                          class="icon-circle ml-1"
                          v-b-tooltip.hover
                          title="Exibir log de envio de e-mail"
                        >
                          <i class="fas fa-history"></i>
                        </a>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div>
              <div class="paginator-info-bottom mt-2">
                <span class="m--font-gray" v-if="data.from"
                  >Exibindo itens de {{ data.from }} a {{ data.to }}, de um
                  total de {{ data.total }}.</span
                >
                <span class="m--font-gray" v-else
                  >Nenhum item a ser exibido.</span
                >
              </div>
              <div class="paginator-list">
                <nav aria-label="...">
                  <ul class="pagination pagination-md">
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = 1"
                        ><i class="fal fa-angle-double-left"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page - 1"
                        ><i class="fal fa-angle-left"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 2"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page - 2"
                      >
                        {{ data.current_page - 2 }}</a
                      >
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == 1 }"
                      v-if="data.current_page > 1"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page - 1"
                      >
                        {{ data.current_page - 1 }}</a
                      >
                    </li>
                    <li class="page-item selected">
                      <a class="page-link paginate">
                        {{ data.current_page }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                      v-if="data.current_page < data.last_page"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page + 1"
                      >
                        {{ data.current_page + 1 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{
                        disabled: data.current_page + 1 == data.last_page,
                      }"
                      v-if="data.current_page + 1 < data.last_page"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page + 2"
                      >
                        {{ data.current_page + 2 }}
                      </a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.current_page + 1"
                        ><i class="fal fa-angle-right"></i
                      ></a>
                    </li>
                    <li
                      class="page-item"
                      :class="{ disabled: data.current_page == data.last_page }"
                    >
                      <a
                        class="page-link paginate"
                        @click.prevent.stop="page = data.last_page"
                        ><i class="fal fa-angle-double-right"></i
                      ></a>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="bv-modal-cancel-invoice"
      ref="modal"
      title="Deseja cancelar as faturas selecionadas?"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOkCancelInvoice"
      ok-title="Sim"
      ok-variant="success"
      cancel-title="Não"
      cancel-variant="metal"
      button-size="md"
      footer-class="p-4"
      size="md"
      content-class="p-3"
      body-class="modal-body-fix"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Motivo do cancelamento"
          label-for="cancelInvoiceReasonInput"
          invalid-feedback="Preencha Motivo do cancelamento."
          :state="cancelInvoiceReasonState"
        >
          <b-form-input
            id="cancelInvoiceReasonInput"
            v-model="cancelInvoiceReason"
            :state="cancelInvoiceReasonState"
            required
          ></b-form-input>
        </b-form-group>
      </form>
    </b-modal>

    <transition name="slideleft" mode="out-in">
      <InvoiceLooseModal v-if="showInvoiceLoose" @updateList="callData" />
    </transition>
    <transition name="slideleft" mode="out-in">
      <InvoiceModal v-if="showInvoiceSave" @updateList="callData" />
    </transition>
    <transition name="slideleft" mode="out-in">
      <InvoiceDuplicateModal v-if="showInvoiceDuplicate" />
    </transition>
    <transition name="fade" mode="out-in">
      <div
        class="m-quick-sidebar-overlay"
        v-if="showInvoiceLoose"
        @click="closeInvoiceLoose()"
      ></div>
    </transition>
    <transition name="fade" mode="out-in">
      <div
        class="m-quick-sidebar-overlay"
        v-if="showInvoiceSave"
        @click="closeSaveInvoice()"
      ></div>
    </transition>
    <transition name="fade" mode="out-in">
      <div
        class="m-quick-sidebar-overlay"
        v-if="showInvoiceDuplicate"
        @click="closesInvoiceDuplicate()"
      ></div>
    </transition>
    <transition name="slideleft" mode="out-in">
      <OmieSendEmailLogModal v-if="showOmieEmailSendLogs" />
    </transition>
    <transition name="fade" mode="out-in">
      <div
        class="m-quick-sidebar-overlay"
        v-if="showOmieEmailSendLogs"
        @click="closeOmieEmailSendLogs()"
      ></div>
    </transition>
    <transition name="slideleft" mode="out-in">
      <OmieSendInvoiceLogModal v-if="showOmieInvoiceSendLogs" />
    </transition>
    <transition name="fade" mode="out-in">
      <div
        class="m-quick-sidebar-overlay"
        v-if="showOmieInvoiceSendLogs"
        @click="closeOmieInvoiceSendLogs()"
      ></div>
    </transition>
    <GenerateSalePerGroup></GenerateSalePerGroup>
    <transition name="slideleft" mode="out-in">
      <LogSendEmail v-if="showLogEmail" @updateList="callData" />
    </transition>
    <transition name="fade" mode="out-in">
      <div
        class="m-quick-sidebar-overlay"
        v-if="showLogEmail"
        @click="closeLogSendEmail()"
      ></div>
    </transition>
  </div>
</template>

<script>
import InvoiceModal from '@/components/invoices/InvoiceModal';
import InvoiceLooseModal from '@/components/invoices/InvoiceLooseModal';
import SelectInvoiceBillingMonth from '@/components/forms/SelectInvoiceBillingMonth';
import SelectInvoiceStatuses from '@/components/forms/SelectInvoiceStatuses';
import SelectInvoiceTypes from '@/components/forms/SelectInvoiceTypes';
import SelectProducts from '@/components/forms/SelectProducts';
import SelectYesNo from '@/components/forms/SelectYesNo';
import GenerateSalePerGroup from '@/components/invoices/GenerateSalePerGroup';
import { returnMessageMixin } from '@/mixins/returnMessageMixin';
import { validationFilterValueMixin } from '@/mixins/validationFilterValueMixin';
import { omieAlertsMixin } from '@/mixins/omieAlertsMixin';
import InvoiceDuplicateModal from '@/components/invoices/InvoiceDuplicateModal';
import OmieSendEmailLogModal from '@/components/invoices/omie/OmieSendEmailLogModal';
import OmieSendInvoiceLogModal from '@/components/invoices/omie/OmieSendInvoiceLogModal';
import LogSendEmail from '@/components/invoices/LogSendEmail';

import { baseApiUrl, externalApiUrl, XAPIKey } from '@/global';

import axios from 'axios';

export default {
  mixins: [returnMessageMixin, validationFilterValueMixin, omieAlertsMixin],
  name: 'Invoices',
  components: {
    InvoiceModal,
    InvoiceLooseModal,
    SelectInvoiceBillingMonth,
    SelectInvoiceStatuses,
    SelectInvoiceTypes,
    SelectProducts,
    GenerateSalePerGroup,
    InvoiceDuplicateModal,
    SelectYesNo,
    OmieSendEmailLogModal,
    OmieSendInvoiceLogModal,
    LogSendEmail,
  },
  data() {
    return {
      indexDownload: -1,
      downloading: false,
      loadingDownload: false,
      cancelInvoiceReason: '',
      cancelInvoiceReasonState: null,
      sortType: localStorage.invoicesSortType
        ? localStorage.invoicesSortType
        : 'billing_month',
      sortReverse: localStorage.invoicesSortReverse
        ? localStorage.invoicesSortReverse
        : false,
      amount: localStorage.invoicesDataAmount
        ? localStorage.invoicesDataAmount
        : 50,
      page: localStorage.invoicesDataPage ? localStorage.invoicesDataPage : 1,
      filters: {
        id: localStorage.invoicesFilterId ? localStorage.invoicesFilterId : '',
        name: localStorage.invoicesFilterName
          ? localStorage.invoicesFilterName
          : '',
        document: localStorage.invoicesDocumentName
          ? localStorage.invoicesDocumentName
          : '',
        group: localStorage.invoicesFilterGroup
          ? localStorage.invoicesFilterGroup
          : '',
        month: localStorage.invoicesFilterMonth
          ? localStorage.invoicesFilterMonth
          : '',
        price: localStorage.invoicesFilterPrice
          ? localStorage.invoicesFilterPrice
          : '',
        type: localStorage.invoicesFilterType
          ? localStorage.invoicesFilterType
          : -1,
        status: localStorage.invoicesFilterStatus
          ? localStorage.invoicesFilterStatus
          : -1,
        cancellation: localStorage.invoicesFilterCancellation
          ? localStorage.invoicesFilterCancellation
          : '',
        billingDateExternal: localStorage.billingDateExternal
          ? localStorage.billingDateExternal
          : '',
      },
      data: [],
      dialog: '',
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
      selected: [],
      allSelected: false,
      invoiceIds: [],
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showInvoiceLoose() {
      return this.$store.state.showInvoiceLoose;
    },
    showInvoiceSave() {
      return this.$store.state.showInvoiceSave;
    },
    showInvoiceDuplicate() {
      return this.$store.state.showInvoiceDuplicate;
    },
    showOmieEmailSendLogs() {
      return this.$store.state.showOmieEmailSendLogs;
    },
    showOmieInvoiceSendLogs() {
      return this.$store.state.showOmieInvoiceSendLogs;
    },
    showLogEmail() {
      return this.$store.state.showLogEmail;
    },
  },
  methods: {
    download() {
      this.downloading = true;
      const url = `${baseApiUrl}/v1/invoice/download-report/${this.convertFilters()}`;
      axios(url)
        .then((res) => {
          const arrData = res.data;

          let csvContent = 'data:text/csv;charset=utf-8,';
          csvContent += [
            Object.keys(arrData[0]).join(';'),
            ...arrData.map((item) => String(Object.values(item).join(';'))),
          ]
            .join('\n')
            .replace(/(^\[)|(\]$)/gm, '');

          const data = encodeURI(csvContent);
          const link = document.createElement('a');

          link.setAttribute('href', data);

          let fileName = `faturas`;

          if (this.start) {
            fileName += `_${this.start}-${this.finish}`;
          }

          fileName = `${fileName}.csv`;

          link.setAttribute('download', fileName);

          link.click();
          this.downloading = false;
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
          this.downloading = false;
        });
    },
    setFilter(filterToChange, id) {
      this.filters[filterToChange] = id;
      this.callData();
    },
    clearFilters() {
      this.filters.id = '';
      this.filters.name = '';
      this.filters.document = '';
      this.filters.group = '';
      this.filters.month = '';
      this.filters.price = '';
      this.filters.product = '';
      this.filters.type = -1;
      this.filters.status = -1;
      this.filters.sortType = 'billing_month';
      this.filters.sortReverse = false;
      this.filters.cancellation = '';
      this.callData();
    },
    setStorageFilters() {
      localStorage.setItem('invoicesFilterId', this.filters.id);
      localStorage.setItem('invoicesFilterName', this.filters.name);
      localStorage.setItem('invoicesDocumentName', this.filters.document);
      localStorage.setItem('invoicesFilterGroup', this.filters.group);
      localStorage.setItem('invoicesFilterMonth', this.filters.month);
      localStorage.setItem('invoicesFilterPrice', this.filters.price);
      localStorage.setItem('invoicesFilterProduct', this.filters.product);
      localStorage.setItem('invoicesFilterType', this.filters.type);
      localStorage.setItem('invoicesFilterStatus', this.filters.status);
      localStorage.setItem(
        'invoicesFilterCancellation',
        this.filters.cancellation
      );
      localStorage.setItem('invoicesDataAmount', this.amount);
      localStorage.setItem('invoicesDataPage', this.page);
      localStorage.setItem('invoicesSortType', this.sortType);
      localStorage.setItem('invoicesSortReverse', this.sortReverse);
    },
    convertFilters() {
      return `?page=${this.page ? this.page : 1}&id=${
        this.filters.id ? this.filters.id : ''
      }&name=${this.filters.name ? this.filters.name : ''}&document=${
        this.filters.document ? this.filters.document : ''
      }&group=${this.filters.group ? this.filters.group : ''}&month=${
        this.filters.month ? this.filters.month : ''
      }&price=${this.filters.price ? this.filters.price : ''}&type=${
        this.filters.type ? this.filters.type : -1
      }&product=${this.filters.product ? this.filters.product : ''}&status=${
        this.filters.status ? this.filters.status : -1
      }&amount=${this.amount}
      &sortType=${this.sortType}
      &sortOrder=${this.sortReverse ? 'DESC' : 'ASC'}
      &cancellation=${
        this.filters.cancellation ? this.filters.cancellation : ''
      }
      &billing_date_external=${
        this.filters.billingDateExternal ? this.filters.billingDateExternal : ''
      }`;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType == sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    callData(invoices) {
      const timeWindow = 700;
      clearTimeout(this.timeoutId);
      this.timeoutId = setTimeout(() => {
        this.data.current_page = null;
        this.invoiceIds = [];
        if (this.allSelected) {
          this.selectAllReport();
        }
        this.setStorageFilters();
        this.getDatas();
        if (invoices) {
          this.selectInvoices(invoices);
        }
      }, timeWindow);
    },
    getIconProducts({ icon }) {
      if (icon) {
        return require(`@/assets/media/img/icons/${icon}.svg`);
      }
      return null;
    },
    downloadInvoiceLegacy(id, customerId) {
      const url = `${baseApiUrl}/v1/invoice/download/${id}?customerId=${customerId}`;
      axios({
        url,
        responseType: 'arraybuffer',
      }).then((res) => {
        this.downloadFile(res, 'customFilename');
      });
    },
    downloadInvoice(id, customerId, indexDownload, product, billing_month) {
      const fileName =
        'fatura_' +
        customerId +
        '_' +
        product.replace(' ', '_') +
        '_' +
        billing_month.substr(0, 7);
      this.indexDownload = indexDownload;
      this.loadingDownload = true;

      const urlHost = `${window.location.protocol}//${window.location.host}`;
      const token = axios.defaults.headers.common.Authorization;

      const urlGriffinInvoice = `${urlHost}/reports/invoice/customer/${customerId}/${id}`;

      // Lambda ira acessar o ambiente de QA
      // Caso for testar configurar a lambda external api no ambiente local ou enviar uma url e token de QA
      const url = `${baseApiUrl}/v1/invoice/download/${id}?token=${token}&url=${urlGriffinInvoice}`;

      axios(url)
        .then((res) => {
          this.downloadFile(res.data, fileName);

          this.indexDownload = -1;
          this.loadingDownload = false;
        })
        .catch((error) => {
          this.logMessageFailed(error.response);

          this.indexDownload = -1;
          this.loadingDownload = false;
        });
    },
    downloadFile(response, filename) {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      const newBlob = new Blob([response.data], { type: 'application/pdf' });

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(newBlob);
        return;
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      //  const data = window.URL.createObjectURL(newBlob);
      const data = `data:application/pdf;base64,${response}`;
      const link = document.createElement('a');
      link.href = data;
      link.download = `${filename}.pdf`;
      link.click();
      setTimeout(() => {
        // For Firefox it is necessary to delay revoking the ObjectURL
        window.URL.revokeObjectURL(data);
      }, 100);
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/invoice/search/${this.convertFilters()}`;
      axios(url).then((res) => {
        this.data = res.data;
        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },
    changeStatus(invoice) {
      const data = {
        id: invoice.id,
        status: invoice.activated_at ? 0 : 1,
      };
      const url = `${baseApiUrl}/v1/invoice/status`;
      axios.post(url, data);
    },
    confirmDel(id) {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja excluir essa fatura?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: 'Confirmar exclusão',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value == true) {
            this.del(id);
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> A fatura não foi excluída!',
              {
                theme: 'toasted-primary',
                type: 'info',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    confirmDeleteMultiples() {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm(
          'Tem certeza que deseja excluir todas as faturas selecionadas?',
          {
            size: 'md',
            contentClass: 'p-3',
            bodyClass: 'modal-body-fix',
            buttonSize: 'md',
            okVariant: 'danger',
            okTitle: 'Confirmar exclusão',
            cancelTitle: 'Cancelar',
            cancelVariant: 'metal',
            footerClass: 'p-4',
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          if (value === true) {
            this.deleteMultiples(this.invoiceIds);
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> As faturas não foram excluídas!',
              {
                theme: 'toasted-primary',
                type: 'info',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    confirmChangeMultipleInvoiceStatus(status) {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm(
          'Tem certeza que deseja alterar o status de todas as faturas selecionadas?',
          {
            size: 'md',
            contentClass: 'p-3',
            bodyClass: 'modal-body-fix',
            buttonSize: 'md',
            okVariant: 'success',
            okTitle: 'Confirmar Alteração',
            cancelTitle: 'Cancelar',
            cancelVariant: 'metal',
            footerClass: 'p-4',
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          if (value === true) {
            this.changeMultipleStatus(this.invoiceIds, status);
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> As faturas não foram alteradas!',
              {
                theme: 'toasted-primary',
                type: 'info',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    confirmGenerateSale() {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Gerar venda para todas as faturas selecionadas?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'success',
          okTitle: 'Gerar venda',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.generateSale(this.invoiceIds);
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> As vendas não foram geradas',
              {
                theme: 'toasted-primary',
                type: 'info',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    confirmGenerateWorkOrder() {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm(
          'Gerar ordem de serviço para todas as faturas selecionadas ?',
          {
            size: 'md',
            contentClass: 'p-3',
            bodyClass: 'modal-body-fix',
            buttonSize: 'md',
            okVariant: 'success',
            okTitle: 'Gerar ordem',
            cancelTitle: 'Cancelar',
            cancelVariant: 'metal',
            footerClass: 'p-4',
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          if (value === true) {
            this.generateWorkOrder(this.invoiceIds);
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> As ordens não foram geradas',
              {
                theme: 'toasted-primary',
                type: 'info',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    confirmSendERP() {
      if (this.invoiceIds.length <= 0) {
        this.$toasted.show(
          '<i class="fas fa-exclamation-triangle"></i> Selecione ao menos uma fatura',
          {
            theme: 'toasted-primary',
            type: 'alert',
            position: 'top-right',
            duration: 5000,
          }
        );
        return;
      }
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Deseja enviar as faturas selecionadas para o ERP?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'success',
          okTitle: 'Faturar',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.sendInvoiceERP(this.invoiceIds);
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> Faturas não enviadas',
              {
                theme: 'toasted-primary',
                type: 'info',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    del(id) {
      const url = `${baseApiUrl}/v1/invoice/delete/${id}`;
      axios(url)
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    deleteMultiples(ids) {
      const url = `${baseApiUrl}/v1/invoice/delete-multiple`;
      axios
        .delete(url, { data: { ids } })
        .then((res) => {
          this.logMessage(res);
          this.callData();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    changeMultipleStatus(ids, status) {
      const url = `${baseApiUrl}/v1/invoice/change-status`;
      axios
        .put(url, { id: ids, status })
        .then((res) => {
          this.logMessage(res);
          this.callData();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    openInvoiceLoose(id) {
      this.$store.state.showInvoiceLoose = id;
    },
    openSaveInvoice(id) {
      this.$store.state.showInvoiceSave = id;
    },
    openLogEmail(id) {
      this.invoice = id;
      this.$store.state.showLogEmail = id;
    },
    openOmieEmailSendLogs() {
      this.$store.state.showOmieEmailSendLogs = true;
    },
    openOmieInvoiceSendLogs() {
      this.$store.state.showOmieInvoiceSendLogs = true;
    },
    openDuplicateInvoice(id, invoice) {
      this.$store.state.showInvoiceDuplicate = id;
      this.$store.state.selectedInvoice = invoice;
    },
    closeInvoiceLoose() {
      this.$store.state.showInvoiceLoose = null;
      this.callData();
    },
    closeSaveInvoice() {
      this.$store.state.showInvoiceSave = null;
      this.callData();
    },
    closeOmieEmailSendLogs() {
      this.$store.state.showOmieEmailSendLogs = null;
      this.callData();
    },
    closeOmieInvoiceSendLogs() {
      this.$store.state.showOmieInvoiceSendLogs = null;
      this.callData();
    },
    closesInvoiceDuplicate() {
      this.$store.state.showInvoiceDuplicate = null;
      this.$store.state.selectedInvoice = null;
    },
    closeLogSendEmail() {
      this.$store.state.showLogEmail = null;
      this.callData();
    },
    selectAllReport() {
      this.invoiceIds = [];
      this.allSelected = !this.allSelected;
      if (this.allSelected) {
        const { data: invoices } = this.data;
        invoices.forEach((invoice) => {
          this.invoiceIds.push(invoice.id);
        });
      }
    },
    select() {
      this.allSelected = false;
    },
    deleteMultipleInvoices() {
      if (this.invoiceIds.length > 0) {
        this.confirmDeleteMultiples();
      }
    },
    changeMultipleInvoiceStatus(status) {
      if (this.invoiceIds.length > 0) {
        this.confirmChangeMultipleInvoiceStatus(status);
      }
    },
    generateInvoiceSale() {
      if (this.invoiceIds.length <= 0) {
        this.$toasted.show(
          '<i class="fas fa-exclamation-triangle"></i> Selecione ao menos uma fatura',
          {
            theme: 'toasted-primary',
            type: 'alert',
            position: 'top-right',
            duration: 5000,
          }
        );
        return;
      }
      this.confirmGenerateSale();
    },
    generateInvoiceWorkOrder() {
      if (this.invoiceIds.length <= 0) {
        this.$toasted.show(
          '<i class="fas fa-exclamation-triangle"></i> Selecione ao menos uma fatura',
          {
            theme: 'toasted-primary',
            type: 'alert',
            position: 'top-right',
            duration: 5000,
          }
        );
        return;
      }
      this.confirmGenerateWorkOrder();
    },
    setAmountPerPage(amount) {
      this.amount = amount;
    },
    generateSale(ids) {
      const url = `${baseApiUrl}/v1/invoice/generate-sale`;
      axios
        .post(url, { ids })
        .then((res) => {
          this.logMessage(res);
          this.callData();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    generateWorkOrder(invoiceIds) {
      let invoiceIdSplited = this.sliceIntoChunks(invoiceIds, 25);
      const url = `${baseApiUrl}/v1/invoice/generate-work-order`;
      invoiceIdSplited.forEach((ids) => {
        axios
          .post(url, { ids })
          .then((res) => {
            this.callData();
          })
          .catch((error) => {
            this.logMessageFailed(error.response);
            this.callData();
          });
      });
      this.logMessage({
        data: {
          message:
            'Faturas enviadas a Omie com sucesso, aguarde a atualização dos status',
        },
      });
    },
    sendInvoiceERP(ids) {
      const url = `${baseApiUrl}/v1/invoice/generate-sale-erp`;
      axios
        .post(url, { ids })
        .then((res) => {
          this.logMessage(res);
          this.callData();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    confirmSendEmails() {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm(
          'Confirma o envio de email para todas as faturas selecionadas?',
          {
            size: 'md',
            contentClass: 'p-3',
            bodyClass: 'modal-body-fix',
            buttonSize: 'md',
            okVariant: 'success',
            okTitle: 'Enviar',
            cancelTitle: 'Cancelar',
            cancelVariant: 'metal',
            footerClass: 'p-4',
            hideHeaderClose: true,
            centered: true,
          }
        )
        .then((value) => {
          if (value === true) {
            this.sendEmails(this.invoiceIds);
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> Emails não foram enviados',
              {
                theme: 'toasted-primary',
                type: 'info',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    sendEmails(ids) {
      const url = `${baseApiUrl}/v1/invoice/send-emails`;
      axios
        .post(url, { ids })
        .then((res) => {
          this.invoiceIds = [];
          this.logMessage(res);
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    sendInvoiceIugu(ids) {
      const url = `${baseApiUrl}/v1/invoice/generate-sale-iugu`;
      axios
        .post(url, { ids })
        .then((res) => {
          this.logMessage(res);
          this.callData();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    confirmSendIugu() {
      if (this.invoiceIds.length <= 0) {
        this.$toasted.show(
          '<i class="fas fa-exclamation-triangle"></i> Selecione ao menos uma fatura',
          {
            theme: 'toasted-primary',
            type: 'alert',
            position: 'top-right',
            duration: 5000,
          }
        );
        return;
      }
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Deseja enviar as faturas selecionadas para o Iugu?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'success',
          okTitle: 'Faturar',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value === true) {
            this.sendInvoiceIugu(this.invoiceIds);
          } else {
            this.$toasted.show(
              '<i class="fas fa-exclamation-triangle"></i> Faturas não enviadas',
              {
                theme: 'toasted-primary',
                type: 'info',
                position: 'top-right',
                duration: 5000,
              }
            );
          }
        });
    },
    confirmCancelInvoices() {
      if (this.invoiceIds.length <= 0) {
        this.$toasted.show(
          '<i class="fas fa-exclamation-triangle"></i> Selecione ao menos uma fatura',
          {
            theme: 'toasted-primary',
            type: 'alert',
            position: 'top-right',
            duration: 5000,
          }
        );
        return;
      }
      this.dialog = '';
      this.$bvModal.show('bv-modal-cancel-invoice');
    },
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity();
      this.cancelInvoiceReasonState = valid;
      return valid;
    },
    resetModal() {
      this.cancelInvoiceReason = '';
      this.cancelInvoiceReasonState = null;
    },
    handleOkCancelInvoice(bvModalEvent) {
      bvModalEvent.preventDefault();
      this.handleSubmitCancelInvoice();
    },
    handleSubmitCancelInvoice() {
      if (!this.checkFormValidity()) {
        return;
      }
      this.cancelInvoice(this.invoiceIds, this.cancelInvoiceReason);
      this.$nextTick(() => {
        this.$bvModal.hide('bv-modal-cancel-invoice');
      });
    },
    cancelInvoice(ids, cancelInvoiceReason) {
      const url = `${baseApiUrl}/v1/invoice/cancel`;
      axios
        .post(url, { ids, cancelInvoiceReason })
        .then((res) => {
          this.logMessage(res);
          this.callData(res.data.notCanceled);
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    selectInvoices(invoices) {
      if (invoices) {
        invoices.forEach((invoice) => {
          this.invoiceIds.push(invoice.id);
        });
      }
    },
  },
  watch: {
    amount() {
      if (this.page == 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    this.getDatas();
    this.fetchOmieAlerts();
    window.scroll(0, 0);
  },
};
</script>
<style>
.bgPlan {
  background-color: rgba(250, 244, 251, 1);
}
.bgSpreadsheet {
  background-color: rgb(208, 255, 222);
}
</style>
